import { createTheme } from '@material-ui/core';
import { colours } from './colours';

const dialogSizing = {
  paperWidthXs: {
    maxWidth: '300px'
  },
  paperWidthSm: {
    maxWidth: '768px'
  }
};

const dialogTheme = {
  MuiModal: {
    root: {
      zIndex: 2100
    }
  },
  MuiDialog: {
    container: {
      alignItems: 'flex-start'
    },
    paper: {
      margin: '0px',
      borderRadius: 0
    },
    ...dialogSizing
  },
  MuiDialogTitle: {
    root: {
      padding: '0px',
      fontSize: '1.3rem',
      fontWeight: 500,
      color: colours.white
    }
  },
  MuiDialogContent: {
    root: {
      padding: '24px'
    }
  },
  MuiDialogActions: {
    root: {
      margin: '8px',
      display: 'block',
      textAlign: 'right'
    }
  },
  MuiDialogContentText: {
    root: {
      fontSize: '1rem',
      color: 'rgb(0, 0, 0)'
    }
  }
};

const snackBarTheme = {
  MuiSnackbar: {
    root: {
      padding: '20px'
    }
  },
  MuiSnackbarContent: {
    root: {
      backgroundColor: 'rgba(0, 0, 0, 0.87)',
      padding: '20px;'
    },
    message: {
      fontSize: '1.1rem',
      padding: '0px'
    },
    action: {
      fontSize: '1rem',
      fontWeight: 500,
      color: colours.green300,
      PaddingRight: '16px'
    }
  }
};

const listTheme = {
  MuiList: {
    root: {
      overflow: 'hidden !important',
      backgroundColor: 'white',
      boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px'
    }
  },
  MuiListItem: {
    root: {
      fontSize: '0.8rem'
    }
  },
  MuiListItemText: {
    root: {
      color: 'black'
    },
    primary: {
      fontSize: '0.9rem',
      fontWeight: 400,
      color: 'black',
      margin: '0px',
      '&$textDense': {
        fontSize: '0.8rem'
      },
      paddingBottom: '0px'
    },
    secondary: {
      fontSize: '0.8rem',
      fontWeight: 400,
      '&$textDense': {
        fontSize: '0.8rem'
      }
    }
  },
  MuiListItemSecondaryAction: {
    root: {
      fontSize: '12px'
    }
  }
};

const palette = {
  type: 'light',
  tonalOffset: '0.07',
  primary: {
    main: colours.lightBlue
  },
  secondary: {
    main: colours.lightBlue
    //   light: colours.orange100,
    //   dark: colours.blue
  }
  // error: {
  //   light: colours.red,
  //   main: colours.red,
  //   dark: colours.red
  // }
};
const typography = {
  useNextVariants: true,
  htmlFontSize: 16,
  fontFamily: 'Inter'
};

const formControls = {
  MuiFormControl: {
    root: {
      marginBottom: 6
    }
  },
  MuiFormControlLabel: {
    label: {
      fontSize: '1rem'
    }
  },
  MuiFormLabel: {
    root: {
      fontSize: '1rem'
    }
  },
  MuiInputLabel: {
    root: { fontSize: '0.9rem', fontWeight: 400 }
  },
  MuiFormHelperText: {
    root: {
      '&$error': { textAlign: 'right' }
    }
  },
  MuiChip: {
    root: { height: 26 },
    label: { fontSize: '0.8rem', fontWeight: 400 }
  },
  MuiSelect: {
    root: { fontSize: '0.8rem', fontWeight: 400 },
    selectMenu: { minHeight: 0 }
  },
  MuiInput: {
    root: { fontSize: '0.8rem', fontWeight: 400 },
    underline: {
      '& input[required]': {
        borderBottom: `1px solid ${colours.yellow}`,
        zIndex: 2
      },

      '& input[required] + div': {
        // hacktastic
        marginLeft: 0,
        marginBottom: -4,
        height: '100%',
        paddingBottom: 4,
        borderRadius: 0,
        borderBottom: `1px solid ${colours.yellow}`,
        zIndex: 2,
        transform: 'rotate(0deg)'
      }
    }
  },
  MuiRadio: {
    root: { padding: '2px 8px' }
  },
  MuiCheckbox: {
    root: { padding: '2px 8px' }
  },
  MuiButton: {
    root: {
      borderRadius: 2,
      fontSize: '0.8rem',
      textTransform: 'none',
      padding: '6px 8px',
      border: 0,
      height: 32,
      letterSpacing: 'normal',
      minHeight: 32,
      fontWeight: 400,
      '&$disabled': {
        color: colours.grey300,
        fontStyle: 'italic'
      }
    }
  },
  MuiIconButton: {
    root: {
      fontSize: '1.5rem'
    }
  },
  MuiSvgIcon: {
    root: {
      fontSize: '1.5rem'
    }
  },
  MuiTab: {
    root: {
      minWidth: 'auto',
      paddingLeft: '1.5rem',
      paddingRight: '1.5rem',
      '@media (min-width: 600px)': {
        minWidth: 'auto'
      }
    }
  }
};

const menu = {
  MuiMenuItem: {
    // Name of the styleSheet
    root: {
      fontSize: '0.9rem',
      fontWeight: 400
    }
  }
};

const muiTable = {
  MuiTableCell: {
    root: {
      padding: 2,
      fontFamily: 'inherit',
      fontSize: '0.8rem'
    }
  }
};

const toolTipTheme = {
  MuiTooltip: {
    popper: {
      zIndex: 2600 // Match Confirmation zIndex
    }
  }
};

const createCustomBzTheme = function (additionalOverrides = {}) {
  return createTheme({
    palette,
    typography,
    overrides: {
      ...menu,
      ...listTheme,
      ...snackBarTheme,
      ...dialogTheme,
      ...formControls,
      ...muiTable,
      ...toolTipTheme,
      ...additionalOverrides
    }
  });
};

const theme = createCustomBzTheme();

export {
  typography,
  formControls,
  menu,
  palette,
  listTheme,
  snackBarTheme,
  dialogSizing,
  dialogTheme,
  createCustomBzTheme
};

export default theme;
